module.exports = __webpack_public_path__ + "img/Goldwyn Hotel.5e0ba8ad.png";